<template>
  <div id="page-login">
    <div class="global-wrapper">
      <div class="bg-img"></div>
      <div class="title-wrapper">
        <h1 v-if="$env.domain == 'yq'">舆情监测预警系统</h1>
        <h1 v-else>群体性事件监测预警系统</h1>
      </div>
      <div class="login-form-wrapper">
        <p class="greeting">Hi，您好！</p>
        <p class="siteDesc" v-if="loginStatus==0"></p>
        <p class="errorDesc" v-else-if="loginStatus==1">用户名和密码不能为空</p>
        <p class="errorDesc" v-else-if="loginStatus==2">验证码输入错误</p>
        <p class="errorDesc" v-else-if="loginStatus==3">您输入的用户名不存在，请重新输入</p>
        <p class="errorDesc" v-else-if="loginStatus==4">用户名或密码有误</p>
        <div class="login-form">
          <Input
            type="text"
            class="login-input login-input-userName"
            v-model="userName"
            placeholder="请输入您的用户名"
            @on-blur="handleBlurUserName"
            @keyup.enter.native="handleSubmit"
          />
          <Input
            type="password"
            class="login-input login-input-password"
            v-model="password"
            placeholder="请输入您的密码"
            @on-blur="handleBlurPassword"
            @keyup.enter.native="handleSubmit"
          />
          <Input
            type="text"
            class="login-input login-input-varify"
            v-model="varifyCustom"
            placeholder="请输入图片验证码"
            @on-blur="handleBlurVarify"
            @keyup.enter.native="handleSubmit"
          />
          <canvas width="100" height="40" id="verifyCanvas"></canvas>
          <img id="img-code" @click="changeVerify" :src="imgUrl" />
          <Checkbox v-model="isRememberPsw" class="checkbox">记住密码</Checkbox>
          <div class="btn-submit" @click="handleSubmit">点击登录</div>
        </div>
      </div>
    </div>
    <div class="beian">版权所有©北京瑞格钛氪科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">京ICP备2024054906号</a><br>
      地址：北京市海淀区中关村大街18号6层6层62853
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //用户的登录状态--0：未进行校验；1：用户名或密码为空；2：验证码输入错误；3：用户名不存在；4：密码错误
      loginStatus: 0,
      //用户输入的<用户名>
      userName: "",
      //用户输入的<密码>
      password: "",
      //用户输入的<图片验证码>
      varifyCustom: "",
      //随机生成的<图片验证码>
      varifyRandom: "",
      //是否勾选了记住密码:默认勾选
      isRememberPsw: true,
      //图片验证码的url
      imgUrl: "",
      timeTest: "test"
    };
  },
  created() {
    document.title = "登录";
    //获取图片验证码
    this.imgUrl = "./kaptcha";
  },
  mounted() {
    //自动填充保存的用户名和密码
    this.userName = localStorage.getItem("spec_uname");
    this.password = localStorage.getItem("spec_pwd");
  },
  methods: {
    //点击<验证码>更新验证码
    changeVerify() {
      let num = Math.ceil(Math.random() * 10); //生成一个随机数（防止缓存）
      this.imgUrl = "./kaptcha?" + num;
    },
    //点击<点击登录>按钮
    handleSubmit() {
      //先判断用户名和密码是否有一个为空
      if (this.userName.trim() == "" || this.password.trim() == "") {
        //更新错误提示状态
        this.loginStatus = 1;
        //改变inut样式
        if (this.userName.trim() == "") {
          $(".login-input-userName .ivu-input").addClass("input-error");
        }
        if (this.password.trim() == "") {
          $(".login-input-password .ivu-input").addClass("input-error");
        }
      } else {
        if (this.isRememberPsw) {
          //保存用户名和密码
          localStorage.setItem("spec_uname", this.userName);
          localStorage.setItem("spec_pwd", this.password);
        } else {
          //删除用户名和密码
          localStorage.removeItem("spec_uname");
          localStorage.removeItem("spec_pwd");
        }

        //发送ajax请求
        this.$ajax({
          method: "post",
          url: "./login",
          data: {
            userName: this.userName,
            password: this.password,
            kaptcha: this.varifyCustom
          }
        })
          .then(res => {
            if (res.data.success) {
              //登录成功，跳转到群组监测页
              this.$Message.success("登录成功");
              //将后端返回的的权限信息放入全局变量authorities中
              //console.log(res.data.data);
              localStorage.setItem("authorities", res.data.data);
              this.$router.push("/home");
            } else {
              if (res.data.code == "402") {
                //验证码输入错误,更新错误提示状态
                this.loginStatus = 2;
                $(".login-input-varify .ivu-input").addClass("input-error");
                //刷新验证码
                this.changeVerify();
                //清空用户输入的验证码
                this.varifyCustom = "";
              } else if (res.data.code == "403") {
                //密码错误，显示错误提示
                this.loginStatus = 4;
                this.changeVerify(); 
                this.varifyCustom = "";
              } else if(res.data.code == '406'){
                this.$Message.error(res.data.message);
                this.changeVerify(); 
                this.varifyCustom = "";
              }
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    },
    //<用户名>输入框失去焦点
    handleBlurUserName() {
      if (this.userName.trim() != "") {
        $(".login-input-userName .ivu-input").removeClass("input-error");
        this.loginStatus = 0;
      }
    },
    //<密码>输入框失去焦点
    handleBlurPassword() {
      if (this.userName.trim() != "") {
        $(".login-input-password .ivu-input").removeClass("input-error");
        this.loginStatus = 0;
      }
    },
    //<验证码>输入框失去焦点
    handleBlurVarify() {
      if (this.varifyCustom.trim() != "") {
        $(".login-input-varify .ivu-input").removeClass("input-error");
        this.loginStatus = 0;
      }
    }
  }
};
</script>

<style lang="less">
#page-login {
  position: fixed;
  background-color: #06003a;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  .beian {
    color: white;
    width: 100%;
    position: absolute;
    bottom: 0;
  }
  .bg-img {
    position: absolute;
    top: 5%;
    left: 10%;
    background-image: url("https://static.rong360.com/upload/png/45/4d/454d9da4e472b3d0bb4fca6e22986ea1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    height: 663px;
    width: 742px;
  }
  .title-wrapper {
    position: absolute;
    top: 25%;
    left: 10%;
    text-align: left;
    h1 {
      font-family: PingFangSC-Medium;
      font-size: 52px;
      color: #ffffff;
      letter-spacing: -1.27px;
      text-shadow: 0 4px 6px #0a215f;
    }
    h3 {
      font-family: PingFangSC-Thin;
      font-size: 37px;
      color: #ffffff;
      letter-spacing: -0.76px;
      text-shadow: 0 4px 6px #0a215f;
      margin-top: -20px;
      margin-bottom: 25px;
    }
    p {
      font-family: PingFangSC-Light;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: -0.41px;
    }
  }
  .login-form-wrapper {
    width: 348px;
    height: 400px;
    background-color: #fff;
    z-index: 999;
    position: absolute;
    right: 10%;
    top: 15%;
    padding: 30px 30px 35px 30px;
    text-align: left;
    .greeting {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: -0.41px;
    }
    .siteDesc {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      letter-spacing: -0.24px;
      margin-bottom: 40px;
    }
    .errorDesc {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: red;
      letter-spacing: -0.24px;
      margin-bottom: 40px;
    }
    .login-input {
      margin-bottom: 23px;
      .input-error {
        border-color: red;
        box-shadow: none;
      }
    }
    .login-input-varify {
      width: 180px;
      .ivu-input {
        border-right: none;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }
    #verifyCanvas {
      display: none;
    }
    #img-code {
      width: 105px;
      height: 32px;
      vertical-align: top;
      cursor: pointer;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    .checkbox {
      .ivu-checkbox {
        margin-right: 5px;
      }
    }
    .btn-submit {
      height: 36px;
      line-height: 36px;
      width: 288px;
      background-color: #415af6;
      border-radius: 5px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: -0.33px;
      cursor: pointer;
      user-select: none;
      margin-top: 30px;
    }
    .btn-submit:hover {
      opacity: 0.8;
    }
  }
}
</style>
